export var Mime;
(function (Mime) {
    Mime["JSON"] = "application/json";
    Mime["MULTIPART_FORM_DATA"] = "multipart/form-data";
    Mime["SVG"] = "image/svg+xml";
    Mime["CSV"] = "text/csv";
})(Mime || (Mime = {}));
